/*global $*/
(function() {

    const selectors = {
        body: 'body',
        eventListItem: '.js-event-item',
        eventCalendar: '.js-event-cal',
        eventCalendarItem: '.js-cal-event',
        modalBackdrop: '.js-event-modal-backdrop',
        modalBox: '.js-even-modal'
    };

    const classes = {
        modalBackdrop: 'event-modal-backdrop js-event-modal-backdrop',
        modalBox: 'event-modal js-even-modal',
        modalTextArea: 'event-description',
        modalImgArea: 'event-image',
    }

    var $eventCalendar = $(selectors.eventCalendar);
    var events = [];

    function init() {
        getEvents();
        bindListEvents();
    }

    function getEvents() {
        $(selectors.eventListItem).each(function(){
            if ($(this).attr('data-event-nr')){
                var event = {
                    eventNr: $(this).attr('data-event-nr'),
                    date: $(this).attr('data-date'),
                    displaydate: $(this).attr('data-display-date'),
                    title: $(this).attr('data-event-title'),
                    description: $(this).attr('data-event-description'),
                    image: $(this).attr('data-event-image')
                }
                events.push(event);
            }
        });
        renderCalendar();
    }

    function renderCalendar() {
        $eventCalendar.simpleCalendar({
            events: events,
            onMonthChange: function() {
                bindCalendarEvents();
            },
            onInit: function() {
                bindCalendarEvents();
            }
        });
    }   

    function showEventModal(eventNr) {
        var event = events[eventNr];

        var $calendarDateElm = $(selectors.eventCalendarItem + "[data-event-nr="+eventNr+"]");
        var eventTile = '<h3>'+event.title+'</h3>';
        var eventDescription = event.description.indexOf('<p>') > -1 ? event.description : '<p>'+event.description+'</p>';
        var eventImage = event.image ? '<img src="'+event.image+'" alt="'+event.title+'"/>' : '';

        $modalBackground = $('<div/>', {
            'class': classes.modalBackdrop
        }).appendTo(selectors.body);

        $modalBox = $('<div/>', {
            'class': classes.modalBox,
            'role': 'dialog'
        }).appendTo($calendarDateElm);

        $textContainer = $('<div/>', {
            'class': classes.modalTextArea,
            'html': eventTile+eventDescription
        }).appendTo($modalBox);

        if (eventImage) {
            $imageContainer = $('<div/>', {
                'class': classes.modalImgArea,
                'html': eventImage
            }).appendTo($modalBox);
        }

        if ($(window).width() < 720) {
            $('html, body').animate({
                scrollTop: $(selectors.eventCalendar).offset().top - 200
            }, 500);
        };

        $modalBox.addClass('show');
        $modalBackground.addClass('show');


        $modalBackground.on('click', function(){
            removeModal();
        });
    }

    function removeModal() {
        $(selectors.modalBackdrop).removeClass('show');
        $(selectors.modalBox).removeClass('show');

        setTimeout(function(){
            $(selectors.modalBackdrop).remove();
            $(selectors.modalBox).remove();
        }, 200);
    }

    function bindCalendarEvents() {
        $(selectors.eventCalendarItem).on('click', function(e) {
            e.preventDefault();
            if ($(this).find(selectors.modalBox).length < 1) {
                showEventModal($(this).attr('data-event-nr'));
            } else {
                removeModal();
            }
        });

        $(selectors.eventCalendarItem).on('mouseover', function(e) {
            if ($(this).find(selectors.modalBox).length < 1) {
                $(this).addClass('hover');
                showEventModal($(this).attr('data-event-nr'));
            }
        });

        $(selectors.eventCalendarItem).on('mouseleave', function(e) {
            if ($(this).hasClass('hover')) {
                removeModal();
            }
        });
    }

    function bindListEvents() {
        $(selectors.eventListItem).on('click', function(e) {
            e.preventDefault();
            var selectedEventDate = $(this).attr('data-date');
            var selectedEventNr = $(this).attr('data-event-nr');
            $eventCalendar.simpleCalendar('gotoDate', selectedEventDate);
            showEventModal(selectedEventNr);
        });
    }
    
    $( document ).ready(function() {
        if ($eventCalendar.length > 0) {
            init();
        }
    });
}());
